import { createRoute } from "../../utils";

import { researchProposalRoutesObj, researchProposalBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const researchProposalRouteMetadata: IRouteMetadataObj<
  typeof researchProposalRoutesObj
> = {
  list: {
    title: "researchProposalManagement",
    lazy: () => import("@/pages/facultyMemberPanel/research/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addResearchProposal",
    lazy: () => import("@/pages/facultyMemberPanel/research/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editResearchProposalOf",
    lazy: () => import("@/pages/facultyMemberPanel/research/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewResearchProposalOf",
    lazy: () => import("@/pages/facultyMemberPanel/research/form/page"),
    mode: "view",
    permission,
  },
};

export const researchProposalRoutes = createRoute<
  typeof researchProposalRoutesObj
>(
  researchProposalRoutesObj,
  researchProposalRouteMetadata,
  researchProposalBreadcrumbs,
);
